import { Injectable } from "@angular/core";
import { filterNilValue, Query } from "@datorama/akita";
import { Observable } from "rxjs";
import { Owners } from "../../../api/nerri/owners/models/owners.model";
import { RegisterState, RegisterStore } from "./register.store";

@Injectable()
export class RegisterQuery extends Query<RegisterState> {
    constructor(store: RegisterStore) {
        super(store);
    }

    public selectOwner(): Observable<Owners> {
        return this.select("owner").pipe(filterNilValue());
    }

    public selectHasRegistered(): Observable<boolean> {
        return this.select("hasRegistered");
    }

    public selectIsLoggedIn(): Observable<boolean> {
        return this.select("isLoggedIn");
    }

    public selectHasValidationError(): Observable<boolean> {
        return this.select("hasValidationError");
    }
}
